// extracted by mini-css-extract-plugin
module.exports = {"container":"noPracticesCard_container__2smZ9","title":"noPracticesCard_title__1jqfO","text":"noPracticesCard_text__gl_tV"};